<template>
    <b-modal
    v-model="openSearchModal"
    title="Buscador para agregar item con precio personalizado"
    header-bg-variant="dark"
    header-text-variant="light"
    size="lg"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    >
    <b-form-input v-model="searchData.codigoItemSearch" placeholder="Ingrese el codigo del item"></b-form-input>
    <template v-slot:modal-footer>
        <b-button variant="danger" @click.prevent="$emit('close-modal')">
                Cancelar
        </b-button>
        <b-button variant="success" :disabled="searchData.codigoItemSearch === ''" @click.prevent="$emit('confirm-search')">
                Buscar
        </b-button>
    </template>
    </b-modal>
</template>

<script>
export default {
    name: "ModalSearchItem",
    props: {
        openSearchModal: {
            type: Boolean,
            default: false
        },
        searchData: {
            type: Object
        }
    }
};

</script>
